/**
 * First 100 Days app — /apps/first-100-days/*
 *
 * One job: a leader new to a role wants to spend their first hundred days
 * listening, sorting what they inherit, and coming out with their first
 * priorities ranked and recorded. The journey runs on Mandate's record
 * (first100Days.ts says where each part is kept); it replaces the separate
 * `first100days/` satellite (DEP-043). Offered in personal workspaces (R18).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import JourneyScreen from './JourneyScreen';
import ListeningTourScreen from './ListeningTourScreen';
import PriorityDiscoveryScreen from './PriorityDiscoveryScreen';
import Day101Screen from './Day101Screen';
import MeetingPlaybookScreen from './MeetingPlaybookScreen';

export default function First100DaysApp() {
  const app = getAppDefinition('first-100-days')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<JourneyScreen />} />
        <Route path="listening" element={<ListeningTourScreen />} />
        <Route path="priorities" element={<PriorityDiscoveryScreen />} />
        <Route path="day-101" element={<Day101Screen />} />
        <Route path="meetings" element={<MeetingPlaybookScreen />} />
        <Route path="*" element={<Navigate to="/apps/first-100-days" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
